import styled from "styled-components";

export const BlocWrapper = styled.div`
  display: flex;
  padding-top: 100px;
  padding-bottom: 100px;
  background: #f7f9fa;
  &.reverse {
    flex-direction: row-reverse;
    background: white;
    .title {
      color: #4ca6e2 !important;
    }
    .ant-btn {
      background: #4ca6e2 !important;
    }
    .content {
      padding-right: 14% !important;
    }
  }
  .contentWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .title {
      color: #ffa400;
      font-size: 28px;
      margin-bottom: 20px;
      padding: 0;
      font-weight: bold;
    }
    .content {
      line-height: 30px;
      padding-bottom: 50px;
      padding-right: 20px;
      font-size: 17px;
      color: #718096;
      text-align: justify;
    }
    .ant-btn {
      border-radius: 10px;
      height: 40px;
      font-size: 20px;
      background: #ffa400;
      margin-left: auto;
      margin-right: auto;
      &:hover {
        color: white;
        font-weight: normal;
        border: 0px;
      }
    }
    flex: 1;
  }
  .voiture {
    filter: drop-shadow(10px 10px 4px lightgrey);
    margin-top: -110px;
  }
  .eolienne {
    max-width: none !important;
  }
  .phoneLock {
    margin-left: 100px;
  }
  .imageWrapper {
    flex: 1;
    height: 400px;
    ${'' /* > span {
      max-width: 100%;
      height: 400px;
    } */}
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    padding-bottom: 20px;
    padding-top: 10px;
    .title {
      margin-top: 5px !important;
    }
    .ant-btn {
      width: 90%;
      a {
        font-size: 18px;
      }
    }
    .content {
      padding-left: 0 !important;
      padding-right: 0 !important;
      padding-bottom: 10px !important;
    }
    .imageWrapper {
      img {
        max-width: 100%;
      }
    }
    .ant-btn {
      margin-bottom: 20px;
    }
  }
`;
